import { apiCallAdmin } from "../../services/api-service";

export const getOrgLogoApi = async () => {
  const response = await apiCallAdmin("get", "get_org_image");
  return response?.data;
};

export const getProfileDetailsApi = async () => {
  return apiCallAdmin("get", "basicprofile");
};

export const updateProfileImageApi = async (data) => {
  return apiCallAdmin("post", "user/image_update", data);
};

export const reportAnIssueApi = async (data) => {
  return apiCallAdmin("post", "report_issue", data);
};

export const getReportIssueTypeApi = async () => {
  const response = await apiCallAdmin("get", "get_issue_type");
  return response?.data;
};

export const getFAQListApi = async () => {
  const response = await apiCallAdmin("get", "help?application=Vehicle");
  return response?.data;
};

export const getOrgListApi = async () => {
  return apiCallAdmin("get", "get_enrolled_orgs");
};

export const getSwitchAccountApi = async (id) => {
  return apiCallAdmin("get", `switch_org/${id}`);
};
